import { render, staticRenderFns } from "./modalidadesGraph.vue?vue&type=template&id=eacebf36&"
import script from "./modalidadesGraph.vue?vue&type=script&lang=js&"
export * from "./modalidadesGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports